import React, { useEffect, useState } from "react";
import Player from "../player";
import Map from "../map";
import API from "../../utils/API";
import { useHistory, useParams } from "react-router-dom";
import MusicBtn from "../../components/SoundBtns/MusicBtn";
import { Village } from "../../data/maps/1";
import store from "../../config/store";
import { resolveStageEntrySpawn, prepareConnectedTransition } from "../../config/worldTransitions";

function VillageWorld(props) {
  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    store.dispatch({ type: "ADD_TILES", payload: { tiles: Village } });
  }, []);

  useEffect(() => {
    API.UpdateSpritePlace("village", id).catch(() => {});
  }, [id]);

  // Consume the pending forest entrance once; render updates must not replace
  // it with Village's default spawn.
  const [initialPosition] = useState(() => resolveStageEntrySpawn(id, "village", props.initialPosition));

  return (
    <div
      id="world-container"
      className="village-world"
      style={{
        position: "relative",
        width: "968px",
        top: "35%",
        marginLeft: "3px",
        border: "4px solid black",
        borderRadius: "5px",
      }}
    >
      <MusicBtn />
      <Map />
      <Player
        avatar={props.avatar}
        avatarName={props.avatarName}
        initialPosition={initialPosition}
        exitZones={{ NORTH: [[6, 0]], EAST: [[14, 7]] }}
        onRightEdge={(position) => {
          if (position[1] === 0) {
            prepareConnectedTransition(id, "village", "NORTH", [position[0] / 64, position[1] / 64]);
            history.push("/forest/" + id);
            return;
          }
          const cell = [position[0] / 64, position[1] / 64];
          const transition = prepareConnectedTransition(id, "village", "EAST", cell);
          if (!transition) return;
          API.UpdateSpritePlace(transition.destination, id)
            .finally(() => history.push("/lake-bed/" + id));
        }}
        returnToWorldMap={() => history.push("/continue/" + id)}
      />
    </div>
  );
}

export default VillageWorld;
